import { render, staticRenderFns } from "./allotinListAction.vue?vue&type=template&id=5a18db73&scoped=true"
import script from "./allotinListAction.vue?vue&type=script&lang=js"
export * from "./allotinListAction.vue?vue&type=script&lang=js"
import style0 from "./allotinListAction.vue?vue&type=style&index=0&id=5a18db73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18db73",
  null
  
)

export default component.exports